const values = [
  { icon: "ri-leaf-line", label: "Madera reforestada" },
  { icon: "ri-paint-brush-line", label: "Pinturas no tóxicas" },
  { icon: "ri-hand-heart-line", label: "Hecho a mano en Colombia" },
  { icon: "ri-pencil-ruler-2-line", label: "Diseño propio" },
];

export default function WhyIokus() {
  return (
    <section id="por-que-iokus" className="w-full scroll-mt-24 bg-background-100">
      <div className="mx-auto w-full max-w-content px-4 py-16 md:px-6 md:py-24">
        <div className="reveal mx-auto mb-10 max-w-2xl text-center md:mb-14">
          <span className="text-xs font-label font-semibold uppercase tracking-[0.18em] text-accent-600">
            Taller de madera
          </span>
          <h2 className="mt-3 text-3xl font-semibold md:text-[40px]">Por qué Iokus</h2>
        </div>

        <div className="grid items-center gap-8 lg:grid-cols-2 lg:gap-14">
          <div className="reveal overflow-hidden rounded-2xl border border-background-200">
            <img
              src="https://storage.helloreaddy.io/project_files/8ede1629-48ad-4015-89eb-b95dfff38e03/6bd3947f-a67a-481b-80f2-561d55caa885_compressed_exterior-tienda-guatape.webp"
              alt="Manos de una familia jugando un juego de mesa de madera hecho por Iokus"
              title="Juegos de madera Iokus que unen generaciones"
              loading="lazy"
              className="h-full w-full object-cover aspect-[5/4]"
            />
          </div>

          <div className="grid grid-cols-2 gap-4 md:gap-5">
            {values.map((value) => (
              <div
                key={value.label}
                className="reveal flex flex-col gap-3 rounded-2xl border border-background-200 bg-background-50 p-5"
              >
                <span className="flex h-11 w-11 items-center justify-center rounded-full bg-accent-100 text-accent-700">
                  <i className={`${value.icon} text-xl`} aria-hidden="true"></i>
                </span>
                <span className="text-sm font-label font-semibold leading-snug text-foreground-900 md:text-base">
                  {value.label}
                </span>
              </div>
            ))}
          </div>
        </div>

        <p className="reveal mx-auto mt-10 max-w-2xl text-center text-base leading-relaxed text-foreground-600 md:mt-14 md:text-lg">
          En Iokus diseñamos y fabricamos juegos de mesa y juguetes de madera en Colombia, con
          materiales responsables y pinturas no tóxicas. Piezas pensadas para durar y para pasar de
          mano en mano.{" "}
          <strong className="font-semibold text-foreground-950">Uniendo generaciones.</strong>
        </p>
      </div>
    </section>
  );
}